<template>
    <div class="download-tool" v-if="tool">
        <div class="head">
            <h1 class="title">{{tool.info.name}}</h1>
            <div class="content">
                <div class="items logo" v-show="tool.info.logo"><img :src="tool.info.logo" /></div>
                <div class="items infos">
                    <p>{{`软件大小: ${tool.info.size}`}}</p>
                    <p>{{`安装环境: ${tool.info.support_os}`}}</p>
                    <p>{{`支持数据库类型: ${tool.info.support_dbs}`}}</p>
                </div>
                <div class="items buttons">
                    <button class="download" @click="$_download">下载</button>
                </div>
            </div>
        </div>
        <div class="steps">
            <div class="title">操作步骤</div>
            <div class="step" v-for="(step, index) in tool.steps" :key="`${index}`">
                <div class="message">{{step.message}}</div>
                <div class="pictures">
                    <img v-for="(picture, pIndex) in step.pictures" :key="`${index}_${pIndex}`" :src="picture">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "download-tool",
        data() {
            return {
                tool: null,
            }
        },
        methods: {
            async $_getInfo(){
                await axios.get("/config/config.download-tool.json")
                    .then(res => res.data)
                    .then(data => { 
                        this.tool = data;
                    });
                
            },
            $_download() {
                window.open(this.tool.info.download_url);
            }
        },
        mounted(){
            this.$_getInfo();
        },
    }
</script>

<style lang="less" scoped>
    .download-tool {
        width: 80%;
        max-width: 1600px;
        min-height: 100%;
        margin: 0 auto;
        padding: 80px 0 60px 0;
        .head {
            width: 100%;
            margin-bottom: 100px;
            .title {
                width: 100%;
                text-align: center;
                font-size: 48px;
                margin: 0 0 60px 0;
                padding: 0;
            }
            .content {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                .items {
                    margin: 0 50px;
                }
                .logo {
                    width: 96px;
                    height: 96px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .infos {
                    p {
                        font-size: 14px;
                        margin: 12px 0;
                    }
                }
                .buttons {
                    button {
                        cursor: pointer;
                        border: none;
                        &:hover, &:active, &:focus {
                            outline-style: none;
                        }
                        &:hover, &:active {
                            opacity: 0.8;
                        }
                    }
                    .download {
                        width: 100px;
                        height: 40px;
                        margin-top: 20px;
                        background-color: rgb(64, 158, 255);
                        color: #fff;
                        border-radius: 20px;
                    }
                }
            }
        }
        .steps {
            width: 100%;
            .title {
                width: 100%;
                padding: 20px;
                font-size: 24px;
                font-weight: 900;
                border-bottom: 1px solid #000;
            }
            .step {
                width: 100%;
                margin-bottom: 50px;
                .message {
                    width: 100%;
                    padding: 10px 20px;
                    font-size: 16px;
                    font-weight: 600;
                }
                .pictures {
                    width: 100%;
                    padding: 10px 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    img {
                        max-width: 100%;
                    }
                }
            }
        }
    }
</style>